/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it legal to download YouTube thumbnails?`)
};

const es_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es legal descargar miniaturas de YouTube?`)
};

const de_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist es legal, YouTube-Thumbnails herunterzuladen?`)
};

const nl_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is het legaal om YouTube-thumbnails te downloaden?`)
};

const fr_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-il légal de télécharger des miniatures YouTube ?`)
};

const it_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È legale scaricare le miniature di YouTube?`)
};

const pt_br2_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É legal baixar thumbnails do YouTube?`)
};

const pt_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É legal descarregar miniaturas do YouTube?`)
};

const ja_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのサムネイルをダウンロードするのは合法ですか？`)
};

const zh_yt_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 YouTube 缩略图是否合法？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq3_q", locale)
	if (locale === "en") return en_yt_hub_faq3_q(inputs)
	if (locale === "es") return es_yt_hub_faq3_q(inputs)
	if (locale === "de") return de_yt_hub_faq3_q(inputs)
	if (locale === "nl") return nl_yt_hub_faq3_q(inputs)
	if (locale === "fr") return fr_yt_hub_faq3_q(inputs)
	if (locale === "it") return it_yt_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq3_q(inputs)
	if (locale === "pt") return pt_yt_hub_faq3_q(inputs)
	if (locale === "ja") return ja_yt_hub_faq3_q(inputs)
	return zh_yt_hub_faq3_q(inputs)
};